import MarkDownRenderer from '../../../../commonComponents/MarkDownRender/MarkDownRender.Component';

export const markdownContent = `
# **What is HawkClient?**

HawkClient is a developer- and Git-friendly **offline-only API client** designed for efficient API testing and development.  
Test, debug, and manage APIs efficiently with a free Postman/Insomnia alternative.



## 👥 **Team Collaboration**

HawkClient stores API requests and collections in **.yaml files**.  
These files can be shared with your team using any version control system, such as Git.



## 🔒 **Privacy**

HawkClient does **not require any sign up or sign in** and does not collect any user data.  
Its offline-only approach ensures a secure and reliable API testing experience.
`;

const AboutHawkClient = () => {
    return (
        <MarkDownRenderer
            title="About HawkClient"
            markDownText={markdownContent}
        />
    );
};

export default AboutHawkClient;
